<div class="notification-dialog">
  <div class="notification-dialog_header">
    <header class="notification-dialog-header" [style.background-image]="'url(' + headerImage + ')'">
      <div class="notification-dialog-header_curve"></div>
    </header>
  </div>
  <div class="notification-dialog_title">
    <h1 class="mat-display-small">{{ title }}</h1>
  </div>
  <div class="notification-dialog_description">
    <p class="mat-body-medium">{{ data.message }}</p>
  </div>
  <div class="notification-dialog_action">
    <button mat-raised-button color="primary" (click)="closeDialog()">
      {{ buttonText }}
    </button>
  </div>
</div>